import { Badge, Grid } from '@chakra-ui/react'

interface BadgeGroupProps {
  items: {
    label: string
    color: string
    isActive: boolean
  }[]
}

export const BadgeGroup = ({ items, ...rest }: BadgeGroupProps) => {
  return (
    <Grid
      sx={{ gridTemplateColumns: `repeat(${items.length}, 1fr)` }}
      {...rest}
    >
      {items.map((item, i) => {
        const { label, color, isActive } = item

        return (
          <Badge
            key={i}
            variant="solid"
            sx={{
              py: 1,
              px: 3,
              bg: isActive ? color : 'neutral.50',
              color: isActive ? 'white' : 'neutral.300',
              borderRadius: 'none',
              fontWeight: 'medium',
              textAlign: 'center',
              _first: {
                borderLeftRadius: 'full',
              },
              _last: {
                borderRightRadius: 'full',
              },
            }}
          >
            {label}
          </Badge>
        )
      })}
    </Grid>
  )
}
